import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { ApplicationType } from "../../entity/ApplicationType";
import { Technology } from "../../entity/Technology";
import { TechnologyCategory } from "../../entity/TechnologyCategory";
import { ApplicationTypeNavHomeViewModel } from "../components/nav-bar/nav-bar.view-model";
import { AbstractCRUDService } from "./AbstractCRUDService";
import { ImageService } from "./ImageService";
import { TechnologyService } from "./TechnologyService";

@Injectable()
export class ApplicationTypeService extends AbstractCRUDService<ApplicationType, number> {

	private readonly imageService: ImageService;

	private constructor(httpClient: HttpClient, imageService: ImageService) {
		super(httpClient);
		this.imageService = imageService;
	}

	public async getAllAsync(): Promise<ApplicationType[]> {
		return [
			{
				id: 1,
				name: "Automotive",
				description: "Automotive Description",
				image: await this.imageService.getByIdAsync("application-type/automotive"),
				technologies: undefined,
			},
			{
				id: 2,
				name: "Building & Architecture",
				description: "Building Description",
				image: await this.imageService.getByIdAsync("application-type/building"),
				technologies: undefined,
			},
			{
				id: 3,
				name: "Consumer Electronics",
				description: "Electronics Description",
				image: await this.imageService.getByIdAsync("application-type/electronics"),
				technologies: undefined,
			},
			{
				id: 4,
				name: "Energy",
				description: "Energy Description",
				image: await this.imageService.getByIdAsync("application-type/energy"),
				technologies: undefined,
			},
			{
				id: 5,
				name: "Lighting",
				description: "Light Description",
				image: await this.imageService.getByIdAsync("application-type/light"),
				technologies: undefined,
			},
			{
				id: 6,
				name: "Logistics",
				description: "Logistics Description",
				image: await this.imageService.getByIdAsync("application-type/logistics"),
				technologies: undefined,
			},
			{
				id: 7,
				name: "Medical & pharmaceutical",
				description: "Medical Description",
				image: await this.imageService.getByIdAsync("application-type/medical"),
				technologies: undefined,
			},
			{
				id: 8,
				name: "Packaging",
				description: "Packaging Description",
				image: await this.imageService.getByIdAsync("application-type/packaging"),
				technologies: undefined,
			},
			{
				id: 9,
				name: "Printing & graphic arts",
				description: "Printing Description",
				image: await this.imageService.getByIdAsync("application-type/printing"),
				technologies: undefined,
			},
			{
				id: 10,
				name: "Textiles & fashion",
				description: "Textiles Description",
				image: await this.imageService.getByIdAsync("application-type/textiles"),
				technologies: undefined,
			},
			{
				id: 11,
				name: "Other",
				description: "Other Fields",
				image: await this.imageService.getByIdAsync("application-type/other"),
				technologies: undefined,
			},
		];
	}

	public async getByIdAsync(id: number): Promise<ApplicationType> {
		const request: ApplicationType[] = await this.getAllAsync();
		for (const applicationType of request) {
			if (applicationType.id === id) {
				return applicationType;
			}
		}
		throw Error("ApplicationType.Id not found");
	}

	public async getNavHomeComponentAsync(): Promise<ApplicationTypeNavHomeViewModel[]> {
		return (await this.getAllAsync()).map((applicationType: ApplicationType): ApplicationTypeNavHomeViewModel =>
			({
				applicationTypeId: applicationType.id,
				applicationTypeName: applicationType.name,
			}));
	}

	public async getTechnologiesComponentAsync(technologyService: TechnologyService, technologyCategory: TechnologyCategory): Promise<ApplicationType[]> {
		const technologies: Technology[] = await technologyService.getAllByTechnologyCategoryAsync(technologyCategory);
		const result: Map<number, ApplicationType> = new Map<number, ApplicationType>();
		for (const technology of technologies) {
			for (const applicationType of technology.applicationTypes) {
				result.set(applicationType.id, applicationType);
			}
		}
		return Array.from(result.values());
	}

}



// WEBPACK FOOTER //
// ./Frontend/src/app/services/ApplicationTypeService.ts